import React from 'react';
import MenuContent from '../MenuContent/MenuContent.mjs';
import Newsletter from '../Newsletter/Newsletter.mjs';
import { StyledContainer } from './DesktopNavigation.styles.mjs';
import DesktopRegionSelector from './DesktopRegionSelector.mjs';

const DesktopNavigation = ({ menu, region, newsletter }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledContainer, null,
            React.createElement(MenuContent, { sections: menu }),
            React.createElement(DesktopRegionSelector, Object.assign({}, region))),
        React.createElement(Newsletter, Object.assign({}, newsletter))));
};

export { DesktopNavigation as default };
//# sourceMappingURL=DesktopNavigation.mjs.map
